import { createContext, PropsWithChildren, useContext } from "react";

export type FeatureFlags = {
    readonly [key: string]: string;
};

export function useFeatureFlags(): FeatureFlags {
    return useContext(FeatureFlagsContext);
}

export type FeatureFlagsProviderProps = {
    readonly featureFlags: FeatureFlags;
};

export const FeatureFlagsProvider = ({
    featureFlags,
    children
}: PropsWithChildren<FeatureFlagsProviderProps>) => {
    return (
        <FeatureFlagsContext.Provider
            value={{
                ...featureFlags
            }}
        >
            {children}
        </FeatureFlagsContext.Provider>
    );
};

export const FEATURE_FLAGS_ID_ATTRIBUTE = "BXP_CONTENT_FEATURE_FLAGS";

const FeatureFlagsContext = createContext({});
